import React, { FC } from 'react'

import { Button } from '@mui/material'
import { isEqual } from 'lodash'

import { CustomButtonProps } from './types'

const CustomButtonComponent: FC<CustomButtonProps> = ({
  children,
  id,
  sx,
  width,
  fullWidth,
  color = 'primary',
  variant = 'contained',
  startIcon,
  disabled,
  ...rest
}) => {
  return (
    <Button
      id={id}
      variant={variant}
      color={color}
      fullWidth={fullWidth}
      startIcon={startIcon}
      disabled={disabled}
      sx={{
        height: '44px',
        borderRadius: '22px',
        textTransform: 'uppercase',
        fontFamily: 'Wix Madefor Text',
        fontWeight: 800,
        letterSpacing: 0.4,
        width: fullWidth ? undefined : width,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  )
}

export const CustomButton = React.memo(CustomButtonComponent, isEqual)
